import { render, staticRenderFns } from "./CreateQueueNewModal.vue?vue&type=template&id=68a83752&scoped=true"
import script from "./CreateQueueNewModal.vue?vue&type=script&lang=js"
export * from "./CreateQueueNewModal.vue?vue&type=script&lang=js"
import style0 from "./CreateQueueNewModal.vue?vue&type=style&index=0&id=68a83752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a83752",
  null
  
)

export default component.exports